import { getFormById } from "@starter/Framework/Store/Starter/Components/Form/FormSelectors";
import { BaseFormHandlerParameter } from "@starter/Framework/Store/Starter/Components/Form/FormTypes";
import { createHandlerChainRunner, Handler } from "@toolkit/Modules/client-framework/HandlerCreator";

export interface DestroyFormHandlerParameter extends BaseFormHandlerParameter {}

type HandlerType = Handler<DestroyFormHandlerParameter>;

export const DispatchDestroyForm: HandlerType = props => {
    const formExist = getFormById(props.getState(), props.parameter.formId);

    if (formExist) {
        props.dispatch({
            type: "Starter/Components/Form/DestroyForm",
            parameter: props.parameter,
        });
    }
};

export const chain = [DispatchDestroyForm];

const destroyForm = createHandlerChainRunner(chain, "DestroyForm");

export default destroyForm;
